import { Service } from '@angular/core';
import { BaseMessageService } from './messages/base-message.service';

export type { Message } from './messages/base-message.service';

@Service()
export class MessageService extends BaseMessageService {}

